import { useFeatureIsOn as useGrowthbookFeatureIsOn } from '@growthbook/growthbook-react'

import { AppFeatures } from '@/core/services/growthbook/types'

export const useFeatureIsOn = (feature: keyof AppFeatures) => {
  return useGrowthbookFeatureIsOn<AppFeatures>(feature)
}
